// @flow
export const UserRegisterLocale = {
  form: {
    header: [
      "Please fill and submit the form below to create your user account.",
      "Aşağıdaki formu doldurarak kullanıcı hesabınızı açabilirsiniz."
    ],
    form_unit: {
      first_name: ["Name", "Ad"],
      last_name: ["Surname", "Soyad"],
      phone: ["Phone Number", "Telefon Numarası"],
      address: ["Address", "Adres"],
      city: ["City", "Şehir"],
      district: ["District", "Semt"],
      country: ["Country", "Ülke"],
      postal_code: ["Postal Code", "Posta Kodu"],
      district_no_results: ["No City Selected", "Seçili Şehir Bulunmuyor"],
      email: ["Email Address / Username for Platform", "Eposta Adresi / Platform Kullanıcı Adı"],
      password: ["Password", "Parola"],
      password_verify: ["Re-enter your password", "Parolanızı tekrar giriniz"],
      submit: ["Register Your Account", "Hesabınızı Oluşturun"]
    }
  },
  error: {
    header: [
      "An error occurred with your registration.",
      "Sisteme kaydınızı yaparken bir hatayla karşılaştık."
    ],
    content: [
      "There is a big chance that you submitted invalid information. Please check all the fields try again.",
      "Yanlış / eksik bilgilerle kaydolmaya çalıştınız. Lütfen bilgilerinizi kontrol edip tekrar deneyiniz."
    ],
    action: ["Return to User Account Register Form", "Kullanıcı Hesap Oluşturma Formuna Geri Dön"]
  },
  completed: {
    header: ["We have successfully created your user account.", "Kullanıcı hesabınızı başarıyla oluşturduk."],
    content: ["You can login to your company dashboard right now.", "Firma yönetim paneline artık giriş yapabilirsiniz."],
    continue_to_login: ["Continue to Login Page", "Giriş Yapma Ekranına Devam Et"]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicAccountPages/UserRegister.locale.js